import PropTypes from 'prop-types';
import React from 'react';
import Navbar from 'react-bootstrap/es/Navbar';
import Logo from "../icon-components/logo";

var MainNavigation = function MainNavigation(_ref) {
  var children = _ref.children,
      logo = _ref.logo,
      logoHref = _ref.logoHref;
  return React.createElement("div", {
    className: "MainNavigation"
  }, React.createElement(Navbar, {
    bsClass: "navigation",
    className: "header-main",
    componentClass: "header"
  }, React.createElement(Navbar.Brand, null, React.createElement("a", {
    href: logoHref,
    className: "logo"
  }, logo || React.createElement(Logo, null))), children));
};

MainNavigation.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  logoHref: PropTypes.string,
  logo: PropTypes.object
};
MainNavigation.defaultProps = {
  logoHref: '/',
  logo: null
};
export default MainNavigation;